import { useEffect as r } from "react";
function f({ to: e }) {
  return r(() => {
    window.location.href = e;
  }, [e]), null;
}
export {
  f as default
};
